import React from 'react';
import { Link } from 'react-router-dom';
import './SiteFooter.css';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>
          <h3>Contact Us</h3>
          <p>Questions about an order, shipping, or support? Reach out directly and we will help.</p>
          <p>
            <strong>Contact Number:</strong>{' '}
            <a href="tel:5612851789">561-285-1789</a>
          </p>
        </div>

        <div>
          <h3>Our Company</h3>
          <p>Anora Store is built around curated merch, collectible drops, and secure worldwide ordering.</p>
          <p>Customers can track orders, reach support quickly, and check out with trusted payment methods.</p>
          <p>Question? Let us help you through support, order tracking, and customer service follow-up.</p>
        </div>

        <div>
          <h3>Policies</h3>
          <div className="site-footer__links">
            <Link to="/support">Support Center</Link>
            <Link to="/track">Track Order</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
          <p className="site-footer__copyright">© {new Date().getFullYear()} Anora Store</p>
        </div>
      </div>
    </footer>
  );
}
